import { Component, Input, OnInit } from '@angular/core';
import { NavigationExtras, Router, RouterOutlet } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { ThemingService } from '../../services/theming.service';
import { DataStoreService } from '../../services/dataStore.service';
import { FeatureService } from '@shared/services/feature.service';
import { GlobalSearchComponent } from '../global-search/global-search.component';
import { PopupService } from '@shared/modules/popup/services/popup.service';
import { GroupBasedAccessService } from '@shared/services/group-based-access-service';
import { Observable } from 'rxjs';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';
import { DashboardService } from 'src/app/modules/dashboards/dashboards.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() pageName: string;
  selectedLanguage: any;
  isMenuCollapsed = true;
  userOption = [
    {
      option: 'Profile and settings',
      translationKey: 'lang.commonComponents.header.appSpecific.ticketingApp.profileNSetting',
      icon: 'ciap-icon icon-Settings'
    },
    {
      option: 'Admin',
      translationKey: 'Admin',
      icon: 'ciap-icon  icon-Person'
    },
    {
      option: 'Logout',
      translationKey: 'lang.commonComponents.header.appSpecific.ticketingApp.logout',
      icon: 'ciap-icon icon-Logout'
    }
  ];
  assignedDropdown: any = [
    { name: 'My Tickets', value: 'myTickets', key: 'item1' },
    { name: 'Assignment Group Tickets', value: 'assignmentGroupTickets', key: 'item2' }
  ];
  userProfile: any;
  routeConfig: any;
  chatBotEnabled: boolean;
  searchExpand: boolean;
  serachKeyword: string;
  appListData: any;
  groupVisibility$: Observable<boolean>;
  appList: any[] = [];
  subscribedappList: any[] = [];
  mainList: any[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private themeService: ThemingService,
    private outlet: RouterOutlet,
    private dataStore: DataStoreService,
    private featureService: FeatureService,
    private popupService: PopupService,
    private groupBasedAccessService: GroupBasedAccessService,
    private runTimeConfigService: RunTimeConfigService,
    private dashboardService: DashboardService
  ) {
    this.routeConfig = {
      title: outlet.activatedRouteData.title
    };

    const appList1 = [];
    this.appListData = this.featureService.getParsedAppList();
    for (const cat of this.appListData) {
      for (const app of cat.appList) {
        app.appCategory = cat.appCategory;
        // app.visible = this.featureService.isFeatureEnabled({ app: app.appID });
        appList1.push(app);
      }
    }
    this.mainList = appList1.slice();
    this.generateDynamicMenuAsPerTenant();

    // this.appListData.forEach(appObj => {
    //   appObj.appList.forEach(application => {
    //     application.groupVisibility = this.checkAppGroupVisibility(application);
    //     // application.visible = application.visible && groupVisibility;
    //   });
    // });
  }

  ticketAssignmentChanged() {}

  ngOnInit() {
    if (this.pageName !== 'login') {
      this.authService.getUserProfile().then((userProfile: any) => {
        this.userProfile = userProfile;
        let name = this.userProfile.given_name + ' ' + this.userProfile.family_name;
        sessionStorage.setItem('loginName', name);
      });
    }
  }

  generateDynamicMenuAsPerTenant() {
    const appList = [];
    this.dashboardService.getMenuList().subscribe((menuList: any) => {
      this.subscribedappList = menuList;
      for (const cat of this.subscribedappList) {
        const app = this.mainList.filter(x => x.appID.toLowerCase() === cat.serviceName.toLowerCase());
        if (app) {
          app[0].visible = cat.subscribed;
          appList.push(app[0]);
        }
      }
      this.appList = appList.slice();

      // console.log('appList', JSON.stringify(this.appList));

      for (const constantConfigApp of this.appListData) {
        constantConfigApp.visibility = false;
        for (const app of constantConfigApp.appList) {
          for (const runTimeApp of this.appList) {
            if (runTimeApp.appID === app.appID && runTimeApp.visible === true) {
              constantConfigApp.visibility = true;
              //   console.log(' visible true from subscribed ', runTimeApp, constantConfigApp);
            }
          }
        }
      }
    });
  }

  profileAction(selectedOption: any) {
    if (selectedOption === 'profileSetting') {
      this.router.navigate(['auth/userprofile']).then(r => {});
    } else if (selectedOption === 'admin') {
      this.router.navigate(['apps/admin']).then(r => {});
    } else {
      const navigationExtras: NavigationExtras = {
        state: {
          doLogout: true
        }
      };
      this.router.navigate(['auth/logout-ad'], navigationExtras);
    }
  }

  clearStorage() {
    this.dataStore.wipeData(true);
  }

  hamburgerMenuAction(selectedOption: string) {
    let userData: any = {};
    userData = JSON.parse(sessionStorage.getItem(this.authService.getAuthenticatedUserId()));
    userData.selectedOption = '';
    this.dataStore.setData(true, this.authService.getAuthenticatedUserId(), userData);
    const appConfig = this.runTimeConfigService.getConfig('appConfig');
    if (selectedOption) {
      if (selectedOption.indexOf('https://') > -1 || selectedOption.indexOf('http://') > -1) {
        const redirectURL = new URL(selectedOption);
        redirectURL.searchParams.set('username', this.authService.getAuthenticatedUserId());
        redirectURL.searchParams.set('ctenv', appConfig.environment);

        window.location.href = redirectURL.toString();
      } else {
        this.router.navigate([selectedOption]).then(r => {});
      }
    } else {
      this.router.navigate(['apps/comingModule']).then(r => {});
    }
  }

  goToUserProfile() {
    this.router.navigate(['auth/userprofile']).then(r => {});
  }

  goToUserKF() {
    this.router.navigate(['apps/knowledge-base/home']).then(r => {});
  }

  goToPage() {
    this.router.navigate(['dashboard/home']);
  }

  toggleChatBot(isEnabled: boolean) {
    this.chatBotEnabled = isEnabled;
  }

  toggleSearch(value: boolean) {
    if (!value) {
      this.searchExpand = false;
    } else {
      this.searchExpand = true;
    }
  }

  globalSearch(serachKeyword: any) {
    const modal = this.popupService.showComponentPopup(
      GlobalSearchComponent,
      { data: serachKeyword },
      {
        windowClass: 'global-search-modal',
        backdrop: 'true',
        centered: true
      }
    );
    this.searchExpand = false;
    this.serachKeyword = '';
  }
  checkAppGroupVisibility(app: any) {
    return new Promise((resolve, reject) => {
      if (app.visibleForAdGroups && app.visibleForAdGroups.length > 0) {
        this.groupBasedAccessService.isUserPartOfGroup({ inAnyOfGroup: app.visibleForAdGroups }).then(
          (userHasGroup: boolean) => {
            resolve(userHasGroup);
          },
          err => {
            reject();
          }
        );
      } else {
        resolve(true);
      }
    });
  }
}
